// Typographie française des textes écrits dans le code : espace insécable avant « ; : ? ! » et dans les guillemets « ».
// Les textes sont écrits avec des espaces simples, lisibles ; ce module les rend corrects à l'affichage.
const INSECABLE = ' ';

export function typo(texte: string): string {
  return texte
    .replace(/ ([;:?!»])/g, `${INSECABLE}$1`)
    .replace(/« /g, `«${INSECABLE}`);
}
